import { useCallback, useEffect, useMemo, useState } from "react";
import { APIMS } from "../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";
import ToastError from "../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faList,
  faMagnifyingGlass,
  faPenToSquare,
  faPlus,
  faTrash,
  faGear
} from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";
import Pagination from "../../../../components/pagination_new";

export default function DataKelas() {
  document.title = "Data Kelas";

  const [getData, setGetData] = useState([]);
  const ascending = 0;
  const token = localStorage.getItem("token");


  const [searchKeyword, setSearchKeyword] = useState("");
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isFetching, setIsFetching] = useState(false);

  const [modalUpdate, setModalUpdate] = useState(false);
  const [dataUpdate, setDataUpdate] = useState();

  const [id, setId] = useState();
  const [modalAdd, setModalAdd] = useState(false);
  
  const storageBranch = localStorage.getItem("ysb_branch_id");

  const [tabTouched, setTabTouched] = useState(false);
  const [activeBranchTab, setActiveBranchTab] = useState("");

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const norm = (value) => (value ?? "").toString().trim();

  const isAllName = (name) => {
    return norm(name).toLowerCase() === "all";
  };

  const getBranchName = (item) => {
    return norm(
      item?.name_branch ?? ""
    );
  };

  const shortBranchLabel = (fullName) => {
    const value = norm(fullName);

    if (!value) {
      return "";
    }

    const bySeparator = value.split(/\s*[-|/]\s*/).filter(Boolean);
    const lastPart = bySeparator[bySeparator.length - 1] || value;
    const words = lastPart.split(/\s+/).filter(Boolean);

    return words[words.length - 1] || lastPart;
  };

  // =========================================
  // GET DATA KELAS
  // =========================================
  const GetResponseData = useCallback(async () => {
    setSearchKeyword("");
    setTablePage(1);
    setIsFetching(true);

    try {
      const response = await APIMS.get(
        `/api/kelas?page=1&limit=1000&ascending=${ascending}&search=`,
        fetchParams
      );

      if (response?.status === 200) {
        const rows = Array.isArray(response?.data?.data)
          ? response.data.data
          : [];

        setGetData(rows);
      } else {
        setGetData([]);
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal memuat data kelas",
      });

      setGetData([]);
    } finally {
      setIsFetching(false);
    }
  }, [fetchParams]);

  useEffect(() => {
    GetResponseData();
  }, [GetResponseData]);

  // =========================================
  // FILTER DATA BERDASARKAN CABANG LOGIN
  // =========================================
  const branchRestrictedData = useMemo(() => {
    let data = Array.isArray(getData) ? getData : [];
    const branch = norm(storageBranch);

    if (branch && branch.toUpperCase() !== "ALL") {
      data = data.filter((item) => {
        const itemBranchId = norm(
          item?.ysb_branch_id ?? item?.branch_id
        );

        const itemBranchName = getBranchName(item).toLowerCase();

        return (
          itemBranchId === branch ||
          itemBranchName === branch.toLowerCase()
        );
      });
    }

    return data;
  }, [getData, storageBranch]);

  // =========================================
  // MEMBUAT TAB CABANG
  // =========================================
  const branchTabs = useMemo(() => {
    const branchMap = new Map();

    branchRestrictedData.forEach((item) => {
      const branchName = getBranchName(item);

      if (!branchName || isAllName(branchName)) {
        return;
      }

      const key = branchName.toLowerCase();

      if (!branchMap.has(key)) {
        branchMap.set(key, branchName);
      }
    });

    return Array.from(branchMap.values()).sort((a, b) =>
      a.localeCompare(b, "id", {
        sensitivity: "base",
      })
    );
  }, [branchRestrictedData]);

  // =========================================
  // DEFAULT TAB CABANG
  // =========================================
  useEffect(() => {
    if (!branchTabs.length) {
      setActiveBranchTab("");
      return;
    }

    const activeStillExists = branchTabs.some(
      (branchName) =>
        branchName.toLowerCase() ===
        activeBranchTab.toLowerCase()
    );

    if (
      tabTouched &&
      activeBranchTab &&
      activeStillExists
    ) {
      return;
    }

    setActiveBranchTab(branchTabs[0]);
  }, [branchTabs, tabTouched, activeBranchTab]);

  // =========================================
  // HAPUS DATA
  // =========================================
  const deleteById = async (id, grade, kelas ) => {
    Swal.fire({
      title: "Hapus data ini?",
      html: `<p class="sims-delete-description">Data <strong></strong> yang dihapus tidak dapat dikembalikan.</p>`,
      icon: "warning",
      customClass: {
        popup: "sims-delete-popup",
        icon: "sims-delete-icon",
        title: "sims-delete-title",
        actions: "sims-delete-actions",
        confirmButton: "sims-delete-confirm",
        cancelButton: "sims-delete-cancel",
        validationMessage: "sims-delete-validation",
      },
      buttonsStyling: false,
      showCancelButton: true,
      confirmButtonText: "Hapus data",
      cancelButtonText: "Batal",
      reverseButtons: true,
      focusCancel: true,

      didOpen: (popup) => {
        popup.querySelector(".sims-delete-description strong").textContent = [grade, kelas || "Tingkatan"].join(" - ");
      },
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          const response = await APIMS.delete(
            `/api/kelas/${id}`,
            fetchParams
          );
  
          if (response.data.error) {
            throw new Error(response.data.message);
          }
  
          return response;
        } catch (error) {
          Swal.showValidationMessage(
            error.response?.data?.message || "Gagal menghapus data"
          );
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        ToastSuccess.fire({
          icon: "success",
          title: "Data berhasil dihapus",
        });
        GetResponseData();
      }
    });
  };

  // =========================================
  // MEMBUKA MODAL UPDATE
  // =========================================
  const viewModalUpdate = (id, kelas) => {
    setId(id);
    setDataUpdate(kelas);
    setModalUpdate(true);
  };

  const nameCollator = useMemo(
    () => new Intl.Collator("id", { sensitivity: "base", numeric: true }),
    []
  );

  // =========================================
  // FILTER DATA SESUAI TAB CABANG
  // =========================================
  const tabFilteredData = useMemo(() => {
    if (!activeBranchTab) {
      return [...branchRestrictedData];
    }

    return branchRestrictedData.filter(
      (item) =>
        getBranchName(item).toLowerCase() ===
        activeBranchTab.toLowerCase()
    );
  }, [branchRestrictedData, activeBranchTab]);

  // =========================================
  // SEARCH DAN SORTING
  // =========================================
  const filteredData = useMemo(() => {
    const keyword = norm(searchKeyword).toLowerCase();

    const searchedData = !keyword
      ? tabFilteredData
      : tabFilteredData.filter((item) => {
          const grade = norm(
            item?.name_grade
          ).toLowerCase();

          const kelas = norm(
            item?.name_kelas
          ).toLowerCase();

          const branch = getBranchName(
            item
          ).toLowerCase();

          const school = norm(
            item?.name_school
          ).toLowerCase();

          return (
            grade.includes(keyword) ||
            kelas.includes(keyword) ||
            branch.includes(keyword) ||
            school.includes(keyword)
          );
        });

    return [...searchedData].sort((a, b) => {
      const gradeCompare = nameCollator.compare(
        norm(a?.name_grade),
        norm(b?.name_grade)
      );

      if (gradeCompare !== 0) {
        return gradeCompare;
      }

      return nameCollator.compare(
        norm(a?.name_kelas),
        norm(b?.name_kelas)
      );
    });
  }, [tabFilteredData, searchKeyword, nameCollator]);

  // =========================================
  // PAGINATION
  // =========================================
  const totalPages = Math.max(1, Math.ceil(filteredData.length / rowsPerPage));

  useEffect(() => {
    setTablePage((page) => Math.min(page, totalPages));
  }, [totalPages]);


  const paginatedData = useMemo(() => {
    const safeRows = Math.max(1, rowsPerPage);
    const start = (tablePage - 1) * safeRows;
    return filteredData.slice(start, start + safeRows);
  }, [filteredData, tablePage, rowsPerPage]);


  return (
    <div className="body sims-page">
      {modalAdd && (
        <ModalAdd
          GetResponseData={GetResponseData}
          show={modalAdd}
          onHide={() => setModalAdd(false)}
        />
      )}

      {modalUpdate && (
        <ModalUpdate
          GetResponseData={GetResponseData}
          id={id}
          dataUpdate={dataUpdate}
          show={modalUpdate}
          onHide={() => setModalUpdate(false)}
        />
      )}

      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon icon={faList} />
            </span>

            <h4 className="page-title-text">
              Data Kelas
            </h4>
          </div>

          <div className="ml-auto menu-navigation-wrapper">
            <button
              type="button"
              onClick={() => setModalAdd(true)}
              className="btn btn-create module-header-button"
            >
              <FontAwesomeIcon icon={faPlus} />

              <span>Tambah Kelas</span>
            </button>

            <Link
              to="/kelas/semester-assignments"
              className="menu-navigation-button"
            >
              <FontAwesomeIcon icon={faGear} /> Konfigurasi Kelas
            </Link>

          </div>
        </div>
      </div>

      <div className="body-content sims-content">
        <div className="sims-column">
          {!isFetching &&
            branchTabs.length > 0 && (
              <div className="sims-tabs">
                {branchTabs.map(
                  (branchName) => {
                    const isActive =
                      branchName.toLowerCase() ===
                      activeBranchTab.toLowerCase();

                    return (
                      <button
                        key={branchName.toLowerCase()}
                        type="button"
                        className={`sims-tab ${
                          isActive ? "active" : ""
                        }`}
                        title={branchName}
                        onClick={() => {
                          setTabTouched(true);
                          setActiveBranchTab(
                            branchName
                          );
                          setTablePage(1);
                        }}
                      >
                        {shortBranchLabel(
                          branchName
                        )}
                      </button>
                    );
                  }
                )}
              </div>
            )}

          {isFetching ? (
            <div className="module-loading">
              <PulseLoader
                color="#3f5bea"
                size={11}
              />
            </div>
          ) : (
            <>
              <div className="module-search-wrap">
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  className="module-search-icon"
                />

                <input
                  type="text"
                  className="module-search-input"
                  placeholder="Cari tingkatan, kelas, cabang, atau sekolah..."
                  value={searchKeyword}
                  onChange={(event) => {
                    setSearchKeyword(event.target.value);
                    setTablePage(1);
                  }}
                />
              </div>

              <div className="sims-table-card mt-3">
                <div className="sims-table-scroll">
                  <table className="sims-table">
                    <thead>
                      <tr>
                        <th className="sims-col-number">
                          No
                        </th>

                        <th style={{width: "16%"}}>
                          Tingkatan
                        </th>

                        <th style={{width: "14%"}}>
                          Nama Kelas
                        </th>

                        <th style={{width: "19%"}}>
                          Cabang
                        </th>

                        <th style={{width: "29%"}}>
                          Sekolah
                        </th>

                        <th className="sims-col-action">
                          Action
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {paginatedData.length > 0 ? (
                        paginatedData.map((row, index) => (
                            <tr key={row?.id || `${row?.name_kelas}-${index}`}>
                              <td className="sims-col-number">
                                <span className="sims-number-badge">
                                  {(tablePage - 1) * rowsPerPage + index + 1}
                                </span>
                              </td>

                              <td>
                                <span className="sims-text-bold " style={{paddingLeft: 23}}>
                                  {row?.name_grade || "-"}
                                </span>
                              </td>

                              <td>
                                <span className="sims-text-bold">
                                  {row?.name_kelas || "-"}
                                </span>
                              </td>

                              <td>
                                <span className="sims-branch-full">
                                  {getBranchName(row) || "-"}
                                </span>
                              </td>

                              <td>
                                <span>
                                  {row?.name_school || "-"}
                                </span>
                              </td>

                              <td className="sims-col-action">
                                <div className="sims-action-wrap">
                                  <button
                                    type="button"
                                    className="sims-action-button sims-action-edit"
                                    title="Update data"
                                    aria-label="Update data"
                                    onClick={() =>
                                      viewModalUpdate(
                                        row?.id,
                                        row
                                      )
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={
                                        faPenToSquare
                                      }
                                    />
                                  </button>

                                  <button
                                    type="button"
                                    className="sims-action-button sims-action-delete"
                                    title="Hapus data"
                                    aria-label="Hapus data"
                                    onClick={() =>
                                      deleteById(
                                        row?.id, row?.name_grade, row?.name_kelas 
                                      )
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faTrash}
                                    />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td
                            colSpan={6}
                            className="sims-empty-state"
                          >
                            <div className="sims-empty-state-content">
                              Data kelas tidak ditemukan
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <Pagination
                  totalRows={filteredData.length}
                  tablePage={tablePage}
                  rowsPerPage={rowsPerPage}
                  onPageChange={setTablePage}
                  onRowsPerPageChange={(value) => {
                    setRowsPerPage(value);
                    setTablePage(1);
                  }}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}